import React from 'react';
import { useSelector } from 'react-redux';
import { Tag, Popover } from 'antd';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import { formatMoney, formatDateTime } from 'utils/textUtils';
import { ORDER_STATUSES } from 'configs/localData';
import GridPhotos from 'components/common/GridPhotos';
import PreviewImage from 'components/common/PreviewImage';
import List from '../../rest/List';
// import Reference from '../../rest/Reference';
// import ProductsList from '../components/ProductsList';
import RestFieldItem from '../../../components/RestField/RestFieldItem';
import ActionGroup from '../../../components/RestActions/ActionGroup';
import EditButton from '../../../components/RestActions/EditButton';
import Filter from '../components/Filter';
import OrderFeature from '../components/OrderFeature';
import DuplicateButton from 'components/RestActions/DuplicateButton';

const OrdersList = (props) => {
  const statuses = useSelector((state) => state.config?.data?.orderStatus);
  const orderRequirements = useSelector(
    (state) => state.config?.data?.orderRequirement,
  );

  return (
    <List
      {...props}
      resource="orders"
      hasExport={false}
      hasSearch={false}
      redirects={{}}
      initialFilter={{ includes: 'products' }}
      defaultOptions={{
        customApiResource: 'orders/me',
      }}
      // expandedRowRender={(data) => <ProductsList {...data} />}
      filter={
        <Filter
          format={(values) => {
            return {
              ...values,
              deadline: values?.deadline
                ? {
                    $lte: values?.deadline?.[1].toISOString(),
                    $gte: values?.deadline?.[0].toISOString(),
                  }
                : undefined,
            };
          }}
        />
      }
    >
      <RestFieldItem
        hasSearch
        sorter
        format={(data, record) => (
          <div style={{ width: 150 }}>
            <div style={{ marginBottom: 10 }}>
              <Link to={`/orders/${record?.codeCustomer}/edit`}>
                <strong>{`#${record?.codeCustomer}`}</strong>
              </Link>
            </div>
            <GridPhotos images={record?.products?.[0]?.productImages || []} />
          </div>
        )}
        source="codeCustomer"
        header="ID"
      />
      <RestFieldItem
        format={(data, record) => (
          <>
            {data}
            <br />
            <PreviewImage src={record?.thumbnail} />
          </>
        )}
        sorter
        source="name"
        header="Name"
      />
      <RestFieldItem
        sorter
        source="status"
        header="orders.status"
        format={(data) => (
          <Tag
            color={
              ORDER_STATUSES?.find((status) => status.value === data)?.color
            }
          >
            <span
              style={{
                color: ORDER_STATUSES?.find((status) => status.value === data)
                  ?.textColor,
              }}
            >
              {statuses?.find((status) => status.value === data)?.text}
            </span>
          </Tag>
        )}
      />
      <RestFieldItem
        sorter
        source="priceOrder"
        header="orders.priceOrder"
        format={(data) => formatMoney(data, 'VND')}
      />
      <RestFieldItem
        source="orderFeature"
        header="orders.orderFeature"
        format={(data) => (
          <div>
            {data?.slice(0, 3)?.map((e) => (
              <OrderFeature value={e} />
            ))}
            {data?.length > 3 ? (
              <Popover
                content={data?.slice(3, data.length).map((e) => (
                  <OrderFeature value={e} />
                ))}
              >
                <Tag>...</Tag>
              </Popover>
            ) : null}
          </div>
        )}
      />
      <RestFieldItem
        source="orderRequirementId"
        header="orders.orderRequirementId"
        format={(data) => (
          <div>
            {orderRequirements?.find(
              (orderRequirement) => orderRequirement.id === data,
            )?.name || i18next.t('error.waitingUpdate')}
          </div>
        )}
      />
      <RestFieldItem
        source="deadline"
        sorter
        header="orders.deadline"
        format={(data) => <div>{formatDateTime(data)}</div>}
      />
      <ActionGroup width={50} icon="ic-more">
        <EditButton />
        <DuplicateButton />
      </ActionGroup>
    </List>
  );
};

OrdersList.propTypes = {};

export default OrdersList;
